module.exports = __webpack_public_path__ + "img/05.91849106.jpg";